import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src={`${process.env.PUBLIC_URL}/images/vibedental-logo4.png`}
                alt="Vibe Dental Studio"
                className="footer-logo-image"
              />
            </div>
            <p className="body-regular footer-description">
              Premium family-friendly dental care designed for comfort and confidence. Your smile deserves the best.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="heading-3 footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><a onClick={() => scrollToSection('hero')}>Home</a></li>
              <li><a onClick={() => scrollToSection('about')}>About Us</a></li>
              <li><a onClick={() => scrollToSection('treatments')}>Treatments</a></li>
              <li><a onClick={() => scrollToSection('gallery')}>Gallery</a></li>
              <li><a onClick={() => scrollToSection('contact')}>Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="heading-3 footer-heading">Our Services</h3>
            <ul className="footer-links">
              <li><a>Dental Implants</a></li>
              <li><a>Root Canal Treatment</a></li>
              <li><a>Cosmetic Dentistry</a></li>
              <li><a>Orthodontics</a></li>
              <li><a>Preventive Care</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="heading-3 footer-heading">Contact Info</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin size={18} />
                <p className="body-small">Vibe Dental Studio, Aruna Residency, Plot 69, Diamond Heights Main Rd, Tellapur, Nallagandla, Telangana 500046</p>
              </div>
              <div className="footer-contact-item">
                <Phone size={18} />
                <p className="body-small">
                  <a href="tel:+919959975995">+91 99599 75995</a>
                </p>
              </div>
              <div className="footer-contact-item">
                <Mail size={18} />
                <p className="body-small">
                  <a href="mailto:vibedentalstudio@gmail.com">vibedentalstudio@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {new Date().getFullYear()} Vibe Dental Studio. All rights reserved. | Designed with care for your smile.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;